import React from "react";
import {useTranslation} from "react-i18next";

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import SupportAccordionCard from "../accordion-card";
import {COLORS} from "../../../../../config/constants";

import './support-empty-requests.scss'

type Props = {
  onCreateRequest(): void;
}

const SupportEmptyRequests = ({onCreateRequest}: Props) => {

  const { t } = useTranslation();

  return (
    <section className='support-empty-requests'>
      <SupportAccordionCard title={t('support__text__myRequests')}>
        <Typography
          variant='body1'
          className='support-empty-requests__message'
          sx={{color: COLORS.BLACK_DARK, letterSpacing: 0, lineHeight: '28px'}}
        >
          {t('support__text__emptyRequestsStart')}
          <Link component='button' onClick={onCreateRequest} underline='always' sx={{color: COLORS.BLUE, cursor: 'pointer'}}>
            {t('support__action__newRequest')}
          </Link>
          {t('support__text__emptyRequestsEnd')}
          .
        </Typography>
      </SupportAccordionCard>
    </section>
  );
};

export default SupportEmptyRequests;
